import { render } from "./pos-warranty.vue?vue&type=template&id=c23c1a6a"
import script from "./pos-warranty.vue?vue&type=script&lang=js"
export * from "./pos-warranty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__